module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-nb.830406f0879a11803281.svg";